import { createSvgIcon } from '@mui/material'

export const WarningIcon = createSvgIcon(
  <svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.2675 1C8.0373 -0.333333 9.9618 -0.333333 10.7316 1L17.6598 13C18.4296 14.3333 17.4673 16 15.9277 16H2.07134C0.531742 16 -0.430508 14.3333 0.339292 13L7.2675 1ZM10 10C10 10.5523 9.55228 11 9 11C8.44771 11 8 10.5523 8 10V5C8 4.44772 8.44771 4 9 4C9.55228 4 10 4.44772 10 5V10ZM8 13C8 13.5523 8.44771 14 9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44771 12 8 12.4477 8 13Z'
      fill='currentColor'
    />
  </svg>,
  'WarningIcon',
)
